import React from 'react'
import { Image, Text, Box } from '@mantine/core'
import SearchMascot from '../../../assets/img/mascot/18.png'

const LoadingData = () => {
  return (
    <Box align='center' my={100}>
      <Image src={SearchMascot} fit='contain' h='200' />
      <Text fz={22} mt={20} c='gray.5'>"No Data Found"</Text>
    </Box>
  )
}

export default LoadingData